import React from 'react';
import { get } from 'lodash';

// React view component to render
import { callWidgetCategoryReasonSummary as CallWidgetCategoryReasonSummaryView } from 'ui/views/widgets/callWidgetCategoryReasonSummary';
import { CallWidgetCategoryReasonSummaryService } from 'services/callWidgetCategoryReasonSummary';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { CallWidgetCategoryReasonSummary } from 'ui/containers/CallWidgetCategoryReasonSummary';
 *
 * // render
 * <CallWidgetCategoryReasonSummary propName='propValue'/>
 */
export class CallWidgetCategoryReasonSummary extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );

      // component state
      this.state = {
        isFetching: true,
        networkStatus: undefined,
        componentData: undefined,
        requestPayload: this.props.requestPayload
    };


    // create service instance
    this.callWidgetCategoryReasonSummaryService = new CallWidgetCategoryReasonSummaryService();

    // start data fetch
    this.fetchComponentData();
}

/**
 * @desc Fetch component response.
 */
async fetchComponentData() {
    log.debug( 'CallWidgetCategoryReasonSummary.fetchComponentData()' );
    
    // cancel ongoing request
    this.callWidgetCategoryReasonSummaryService.cancel();

    // fetch component data
    const { status, data } = await this.callWidgetCategoryReasonSummaryService.fetchComponentData( {
        url: this.props.widget.url,
        data: this.props.requestPayload
    } );

    // check if response status was success
    if( SERVICE_RESPONSE_STATUS.SUCCESS !== status ) {
        this.setState( {
            isFetching: false,
            networkStatus: SERVICE_RESPONSE_STATUS.FAILURE
        } );
    } else {
        this.setState( {
            isFetching: false,
            networkStatus: SERVICE_RESPONSE_STATUS.SUCCESS,
            componentData: data,
        } );
    }
}

    /**
     * @desc Render a React view component
     */
    render() {
        return (
            <CallWidgetCategoryReasonSummaryView
                isFetching={ this.state.isFetching }
                networkStatus={ this.state.networkStatus }
                componentData={ get( this.state, 'componentData', {} ) }
                requestPayload={ this.state.requestPayload }
            />
        );
    }
}

// set display name
CallWidgetCategoryReasonSummary.displayName = 'CallWidgetCategoryReasonSummary';

// set default props
CallWidgetCategoryReasonSummary.defaultProps = {};

// prop types
CallWidgetCategoryReasonSummary.propTypes = {};
